module.exports = __webpack_public_path__ + "img/gywmbaner.a33c04e3.png";